// this file is generated by update_shopify_store_data.py at 2026-03-18 20:23:17.007646
var courses = [
    {
        "course_id": "82891C1F-2EB0-F011-99A4-005056A725AD",
        "course_version": 2,
        "name": "Medical Acid Base Explained Clearly",
        "course_type": 1,
        "author_information": "Roger Seheult, MD",
        "description": "Medical Acid-Base + ABGs Explained Clearly\r\nConfidently interpret acid-base and arterial blood gas results with a clear, systematic approach. In this updated course, renowned educator Roger Seheult, MD simplifies complex physiology into practical steps that clinicians can immediately apply to real-world patient care.\r\n\r\n\r\nThrough engaging video lectures, quizzes, and case-based exercises, you\u2019ll move beyond memorization to true understanding\u2014bridging the gap between theory and bedside diagnosis.\r\n\r\n\r\nWhat You\u2019ll Learn\r\n-A step-by-step method for interpreting lab results and recognizing abnormal acid-base patterns\r\n-The four primary disorders: metabolic acidosis, respiratory acidosis, metabolic alkalosis, and respiratory alkalosis\r\n-How to apply Winter\u2019s Formula, the Anion Gap, and compensatory mechanisms with confidence\r\n-Practical, case-based examples that strengthen clinical reasoning\r\n-A clinician\u2019s perspective on nuanced acid-base findings and real-world application\r\n-Trusted by universities, students, and practicing clinicians, this course transforms confusion into clarity and equips you with the confidence to manage even the most complex acid-base cases.\r\n\r\nIncludes 3 CME (Category 1), MOC Points, and CE Credits.",
        "learning_objectives_html": "<div class=\"objectives-container\">\r\n<p>Upon completion of this continuing medical education activity, participants should be able to:</p>\r\n<ul>\r\n    <li>Use a systematic approach to the medical acid-base and its associated disorders.</li>\r\n    <li>Calculate the anion gap and apply it to any medical acid-base disorder present in a patient.</li>\r\n    <li>Identify multiple concurrent medical acid-base disorders in a patient.</li>\r\n</ul>\r\n</div>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "A2D99439-7B98-F011-999F-005056A70840",
                "course_category_name": "Medcram",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DFE5D158-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CE - Continuing Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6133B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiac Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5A8D6672-C8AA-F011-999E-005056A78EAA",
                "course_category_name": "MedCram",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                "course_category_name": "Course",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1E8E3774-CEC9-E511-82AF-005056B150D3",
                "course_category_name": "Diagnostic Tests & Examinations",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CBF0E856-7B98-F011-999F-005056A70840",
                "course_category_name": "Medcram",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8833B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Endocrine Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AFB1D1BB-7B98-F011-999F-005056A70840",
                "course_category_name": "Medcram",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ACCME",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "AMA PRA Category 1 Credits&trade;:&nbsp;Continuing Education Company, Inc. (CEC) is\r\naccredited by the Accreditation Council for Continuing Medical Education (ACCME) to\r\nprovide continuing medical education for physicians.<br />\r\n<br />\r\nContinuing Education Company, Inc. designates this enduring material for a maximum of\r\n3 AMA PRA <br />\r\n<br />\r\nCategory 1 Credits&trade;. Physicians should claim only the credit\r\ncommensurate with the extent of their participation in the activity.",
            "credit_display_name": "CME",
            "credit_units": 3.0,
            "credit_unit_display_name": "<em>AMA PRA Category I Credit(s)&trade;</em>"
        },
        "sub_courses": []
    }
];